import axios from "axios";

const UNHANDLED_ERROR_MESSAGE =
  "Zoinks! Something went wrong. Try gain later or contact an admin.";
const HANDLED_ERROR_MESSAGE = "There were validation errors.";

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    "content-type": "application/json",
    "appstream-custom-url-domain": "teleportal.live"
  }
});

// Uniform front-end error handler
export const resolveWithStatus = (response: any) => {
  const { data, status }: any = response;

  if (response.status >= 200 && response.status <= 299) {
    return response;
  } else {
    const errors: any = {
      message: null,
      route: null,
      status: status
    };

    switch (status) {
      case 500:
        errors.message = UNHANDLED_ERROR_MESSAGE;
        break;

      case null:
        errors.message = UNHANDLED_ERROR_MESSAGE;
        break;

      default:
        // Take the curated message from the backend.
        errors.message = HANDLED_ERROR_MESSAGE;

        if (data.message) {
          errors.message = data.message;
        }

        if (data.route) {
          errors.route = data.route;
        }
    }

    return Promise.reject(errors);
  }
};

export const testMethod = () => {
  return api.get(`/hello`).then(resolveWithStatus);
};

export default api;
